import "core-js/modules/es.array.push.js";
import { ElForm as Form } from 'element-plus';
export default {
  name: 'LyForm',
  components: {
    RenderBtn: {
      functional: true,
      // 函数式组件 - 无 data 和 this 上下文 => better render
      props: {
        row: Object,
        formItemList: Array,
        formModel: Object,
        render: Function,
        ellipsis: Boolean
      },
      /**
         * @param {Function} createElement - 原生创建dom元素的方法， 弃用，推荐使用 jsx
         * @param {Object} ctx - 渲染的节点的this对象
         * @argument 传递参数 row index
         */
      render(ctx, createElement) {
        const {
          formItemList,
          formModel,
          row
        } = ctx;
        const renderContent = ctx.render(row, formModel, formItemList) || '';
        return typeof renderContent === 'string' ? createElement('span', renderContent) : renderContent;
      }
    },
    RenderDom: {
      functional: true,
      // 函数式组件 - 无 data 和 this 上下文 => better render
      props: {
        row: Object,
        index: Number,
        datakey: String,
        render: Function,
        model: Object,
        ellipsis: Boolean
      },
      /**
         * @param {Function} createElement - 原生创建dom元素的方法， 弃用，推荐使用 jsx
         * @param {Object} ctx - 渲染的节点的this对象
         * @argument 传递参数 row index
         */
      render(ctx, createElement) {
        const {
          row,
          index,
          model
        } = ctx;
        const renderContent = ctx.render(model || row, row, index) || '';
        return typeof renderContent === 'string' ? createElement('span', renderContent) : renderContent;
      }
    }
  },
  props: {
    ...Form.props,
    layoutFormProps: {
      type: Object,
      default: function () {
        return {};
      }
    },
    formItemList: {
      type: Array,
      default: function () {
        return [];
      }
    },
    model: {
      type: Object,
      default: function () {
        return {};
      }
    },
    configBtn: {
      type: Array,
      default: function () {
        return [];
      }
    },
    renderBtn: {
      type: [Function, Boolean],
      default: false
    }
  },
  data() {
    return {
      refs: 'form_' + parseInt(Math.random() * 1e10),
      folded: false,
      formInstance: {}
    };
  },
  computed: {
    formItemComponents() {
      const components = {};
      this.formItemList.forEach(el => {
        if (el.components && Object.keys(el.components).length) {
          for (const [key, value] of Object.entries(el.components)) {
            components[key] = value;
          }
        }
      });
      return components;
    },
    formItemListfilter() {
      // 表单控件参数过滤
      return this.formItemList.map(it => {
        if (!it.span) {
          it.span = 6;
        }
        return it;
      }).filter(it => {
        if (it.isHiden && typeof it.isHiden === 'function') {
          const status = it.isHiden(this.model, it, this.fromProps);
          if (status) {
            return false;
          }
          return true;
        }
        return true;
      });
    },
    isBtnHiden() {
      return this.layoutFormProps?.fromLayProps?.isBtnHiden || false;
    },
    rowLayout() {
      // row 栅格布局参数
      return this.layoutFormProps?.rowLayProps || {};
    },
    formLayout() {
      // form 布局参数
      return this.layoutFormProps?.fromLayProps || {};
    },
    fromProps() {
      // from表单属性
      return {
        ...this.formLayout,
        model: this.model
      };
    },
    getBtnColSpan() {
      // 按钮折行计算方式
      const {
        rowNum,
        columnRow
      } = this.getRowColsAlgorithm;
      const lastColumn = columnRow.length ? columnRow[rowNum - 1] ? columnRow[rowNum - 1] : columnRow[columnRow.length - 1] : [];
      let totalSpan = 0;
      const BtnColSpan = this.layoutFormProps?.fromLayProps?.btnColSpan || 0;
      lastColumn.forEach(element => {
        totalSpan += this.formItemListfilter[element]?.span;
      });
      const hasSpan = 24 - totalSpan;
      if (!this.folded && BtnColSpan && BtnColSpan <= hasSpan) {
        return hasSpan;
      }
      return 24;
    },
    getRowColsAlgorithm() {
      // 折行计算方式
      /*
      let rowIndex = []
      let columnRow = []
      let eveySomeSpan = 0
      this.formItemListfilter.map((it, index) => {
        const spanYu = 24 - eveySomeSpan
        if (index !== (this.formItemListfilter.length - 1)) {
          if (it.span <= spanYu) {
          eveySomeSpan += it.span
          rowIndex.push(index)
        } else {
           columnRow.push(rowIndex)
           eveySomeSpan = it.span
           rowIndex = [index]
        }
        } else {
          rowIndex.push(index)
          columnRow.push(rowIndex)
          eveySomeSpan = 0
          rowIndex = []
        }
      })
      const opt = {
        columnRow,
        rowNum: columnRow.length,
        columnNodeIndex: columnRow.map(it => it[it.length - 1])
      }
      */

      let pre = 0;
      const groupArrayList = [];
      const columnRows = [];
      let rowColIndex = -1;
      for (let i = 0; i < this.formItemListfilter.length; i++) {
        const item = this.formItemListfilter[i];
        pre += item.span;
        if (pre > 24) {
          if (i === this.formItemListfilter.length - 1) {
            let statIndex = columnRows.length ? columnRows[columnRows.length - 1].endIndex : 0;
            columnRows.push({
              statIndex,
              endIndex: i
            });
            if (item.span <= 24) {
              columnRows.push({
                statIndex: i,
                endIndex: i + 1
              });
            }
          } else {
            let statIndex = columnRows.length ? columnRows[columnRows.length - 1].endIndex : 0;
            let endIndex = i;
            columnRows.push({
              statIndex,
              endIndex
            });
          }
          pre = item.span;
        } else {
          if (i === this.formItemListfilter.length - 1) {
            let statIndex = columnRows.length ? columnRows[columnRows.length - 1].endIndex : 0;
            columnRows.push({
              statIndex,
              endIndex: pre < 24 ? i + 1 : i + 1
            });
          } else {
            if (pre === 24) {
              let statIndex = columnRows.length ? columnRows[columnRows.length - 1].endIndex : 0;
              let endIndex = i + 1;
              // debugger
              columnRows.push({
                statIndex,
                endIndex
              });
              pre = 0;
            }
          }
        }
      }
      columnRows.forEach(it => {
        groupArrayList.push(this.formItemListfilter.slice(it.statIndex, it.endIndex));
      });
      const columRowIndexs = groupArrayList.map(it => {
        return it.map(its => rowColIndex += 1);
      });
      const opts = {
        columnRow: columRowIndexs,
        rowNum: columRowIndexs.length,
        columnNodeIndex: columRowIndexs.map(it => it[it.length - 1])
      };
      return opts;
    },
    formItem() {
      // 表单控件折行处理逻辑
      const minFoldRow = this.layoutFormProps?.fromLayProps?.minfoldRows || 0;
      //const isMinFoldRow = this.isfold
      const {
        // columnRow, 
        columnNodeIndex
      } = this.getRowColsAlgorithm;
      if (this.folded) {
        const lastFoldIndex = columnNodeIndex.length ? columnNodeIndex[minFoldRow - 1 > 0 ? minFoldRow - 1 : 0] ? columnNodeIndex[minFoldRow - 1 > 0 ? minFoldRow - 1 : 0] : columnNodeIndex[columnNodeIndex.length - 1] : 9999;
        return this.formItemListfilter.map((it, index) => {
          if (index > lastFoldIndex) {
            it.isfold = true;
          } else {
            it.isfold = false;
          }
          return it;
        });
      }
      return this.formItemListfilter.map(it => {
        it.isfold = false;
        return it;
      });
    },
    isRenderBtn() {
      // 自定义按钮渲染
      if (typeof this.renderBtn === "function") {
        return true;
      }
      return false;
    },
    isfold() {
      // 折行状态
      const minFoldRow = this.layoutFormProps?.fromLayProps?.minfoldRows || 0;
      const {
        //  columnRow,
        rowNum
        // columnNodeIndex
      } = this.getRowColsAlgorithm;
      if (minFoldRow && minFoldRow < rowNum) {
        return true;
      }
      return false;
    }
  },
  watch: {
    isfold: {
      handler(val) {
        this.folded = val;
      },
      immediate: true
    }
  },
  created() {
    this.$nextTick(() => {
      this.formInstance = this.refsForm();
    });
  },
  mounted() {},
  methods: {
    refsForm() {
      for (let c in this.$refs[this.refs]) {
        // 拷贝继承Form方法到父组件
        const methodItem = function (...params) {
          // console.log('methods', this.$refs[this.refs])
          this.$refs[this.refs][c](...params);
        };
        this[c] = methodItem.bind(this);
        /* this[c] = function (...params) {
            this.$refs[this.refs][c](...params)
           }.bind(this) */
      }
      // console.log('methods', Form, this.$refs[this.refs])
      return this.$refs[this.refs];
    },
    confirm() {
      this.$emit('confirm', this.$refs[this.refs], this.model);
    },
    reset() {
      this.$emit('reset', this.$refs[this.refs], this.model);
    },
    changefolded() {
      this.folded = !this.folded;
    }
  }
};